'use client'

import { useTheme } from 'next-themes'
import { Toaster } from 'sonner'
import { useEffect, useState } from 'react'

export function ThemeAwareToaster() {
  const { resolvedTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  useEffect(() => setMounted(true), [])

  const theme = mounted && resolvedTheme === 'dark' ? 'dark' : 'light'

  return <Toaster theme={theme} richColors position="bottom-center" />
}
